import { createEventTracker } from '../util';
import { DxIdVersionSentAnalytics, MetricInsightBaseAnalytics } from './types';

export const trackDxIdVersionSent = createEventTracker<DxIdVersionSentAnalytics>(
  'DxIdVersion sent in computeMetric',
);

export const trackMetricInsightsPageViewed =
  createEventTracker<MetricInsightBaseAnalytics>('Metric Insight Viewed');

export const trackMetricInsightShared =
  createEventTracker<MetricInsightBaseAnalytics>('Metric Insight Shared');
